import React, { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, width = "fit-content" }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Only trigger once when element comes into view
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after first reveal
        }
      },
      { threshold: 0.1 } // Trigger when 10% of element is visible
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{
        position: "relative",
        width,
        overflow: "hidden",
      }}
    >
      {/* Main content with fade-in and slide-up */}
      <div
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(75px)",
          transition: "opacity 0.5s ease-out 0.25s, transform 0.5s ease-out 0.25s",
        }}
      >
        {children}
      </div>
      {/* Sliding overlay effect */}
      <div
        style={{
          position: "absolute",
          top: 4,
          bottom: 4,
          left: isVisible ? "100%" : 0,
          right: 0,
          background: "var(--brand)",
          zIndex: 20,
          transition: "left 0.5s ease-in",
        }}
      />
    </div>
  );
};
